import {
  InteractionRequiredAuthError,
  type AccountInfo,
  type IPublicClientApplication,
} from '@azure/msal-browser';

function resourceScopes(resource: string): string[] {
  return [`${resource.replace(/\/$/, '')}/.default`];
}

// Silent-only acquisition. The SharePoint file picker requests tokens from an async
// postMessage handler, which is not a user gesture, so an interactive popup fallback
// there is always blocked by the browser and surfaces as a misleading popup_window_error.
// Callers servicing a picker "authenticate" command must use this and handle failure by
// reporting an error back to the picker rather than opening a popup.
export async function acquireSharePointTokenSilent(
  instance: IPublicClientApplication,
  account: AccountInfo,
  resource: string,
): Promise<string> {
  const resp = await instance.acquireTokenSilent({ scopes: resourceScopes(resource), account });
  return resp.accessToken;
}

// Silent acquisition with an interactive popup fallback. Only safe to call directly from a
// user gesture (e.g. the click that opens the picker), where the popup is permitted.
export async function acquireSharePointTokenInteractive(
  instance: IPublicClientApplication,
  account: AccountInfo,
  resource: string,
): Promise<string> {
  const scopes = resourceScopes(resource);
  try {
    const resp = await instance.acquireTokenSilent({ scopes, account });
    return resp.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      const resp = await instance.acquireTokenPopup({ scopes, account });
      return resp.accessToken;
    }
    throw err;
  }
}
